{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://modules/release",
  "title": "Release",
  "description": "Release create/edit form field catalog.",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "Release ID",
      "widget": "hidden"
    },
    "name": {
      "type": "string",
      "title": "Name",
      "maxLength": 250,
      "noBlank": true
    },
    "expectedReleaseDate": {
      "type": "string",
      "title": "Expected Release Date",
      "format": "date",
      "widget": "date"
    },
    "ignoreBrokerage": {
      "type": "boolean",
      "title": "Ignore Brokerage",
      "widget": "checkbox",
      "default": false
    },
    "soldShareOnlyToBroker": {
      "type": "boolean",
      "title": "Transfer Sold shares only to broker",
      "widget": "checkbox",
      "default": false
    },
    "bulkExecutionName": {
      "type": "string",
      "title": "Bulk Execution Name",
      "maxLength": 250
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 2000,
      "adapterProps": { "rows": 4 }
    },
    "releasePlanTypeCategoryId": {
      "type": "string",
      "title": "Award Type",
      "widget": "select"
    },
    "automationGrantIds": {
      "type": "array",
      "title": "Grant Name",
      "widget": "multi-select",
      "items": { "type": "string" }
    }
  }
}
